/**
 * @generated SignedSource<<cca44b6ba9b18b2c1133f10426bec5ae>>
 * @relayHash 46fbab7833b198a79aed78467c085734
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 85186ed9b7c7028f7f3e746fa7c3343b72d0ffc055bf17af7aea95119222e3d7

import type { ConcreteRequest } from 'relay-runtime';
export type TopNavSettingsMenuQuery$variables = {
  cloudId: string;
  skipDelegatedAdminCheck: boolean;
  skipJsmAdminCheck: boolean;
};
export type TopNavSettingsMenuQuery$data = {
  readonly jira?: {
    readonly canManageCustomOnboarding: boolean | null;
  } | null;
  readonly jsmAdmin?: {
    readonly hasJsmAdminAccess: boolean | null;
  } | null;
};
export type TopNavSettingsMenuQuery = {
  response: TopNavSettingsMenuQuery$data;
  variables: TopNavSettingsMenuQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipDelegatedAdminCheck"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipJsmAdminCheck"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  {
    "condition": "skipDelegatedAdminCheck",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "canManageCustomOnboarding",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "key",
                "value": "MANAGE_CUSTOM_ONBOARDING"
              }
            ],
            "kind": "ScalarField",
            "name": "hasGlobalPermission"
          }
        ]
      }
    ]
  },
  {
    "condition": "skipJsmAdminCheck",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": "jsmAdmin",
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v1/*: any*/)
            ],
            "kind": "ScalarField",
            "name": "hasJsmAdminAccess"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "TopNavSettingsMenuQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TopNavSettingsMenuQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "85186ed9b7c7028f7f3e746fa7c3343b72d0ffc055bf17af7aea95119222e3d7",
    "metadata": {},
    "name": "TopNavSettingsMenuQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ace42ec490949d2783146fcf12bbcc7a";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
